if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.updateStickyBar();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      updateStickyBar() {
        // Sticky functionality
        const pdpATC = document.querySelector('.product-form__submit') || null;
        const productUpsellsSection = document.querySelector('.section--product-upsells') || null;
        const stickyWrapper = document.querySelector('.sticky-wrapper') || null;
        const footer = document.querySelector('footer.siteFooter');
        const targetSection = productUpsellsSection ?? pdpATC;

        if (!targetSection || !stickyWrapper) return;

        function isElementInViewport(el) {
          let rect = el.getBoundingClientRect();
          return rect.top + el.clientHeight >= 0;
        }

        const toggleBtnClass = () => {
          // Check if chat widget is there and if so move it out the way
          if (isElementInViewport(targetSection)) {
            stickyWrapper && stickyWrapper.classList.remove('sticky');
            if (stickyWrapper) {
              footer.style.paddingBottom = '0px';
            }
          } else {
            stickyWrapper && stickyWrapper.classList.add('sticky');
            if (stickyWrapper) {
              footer.style.paddingBottom = `${stickyWrapper.clientHeight}px`;
            }
          }
        };

        toggleBtnClass();

        window.addEventListener('resize', () => {
          toggleBtnClass();
        });

        window.addEventListener('scroll', () => {
          toggleBtnClass();
        });

        // When user adds to cart, utilize current buy box and submit form
        const stickyAtc = document.querySelector('.sticky-submit') || null;
        const buyBoxAtc = document.querySelector('.product-form__submit') || null;
        stickyAtc &&
          stickyAtc.addEventListener('click', () => {
            buyBoxAtc.click();
          });

        // check for change in buybox, if there is update sticky
        let formsProduct = document.querySelectorAll('.product-form') || false;
        const stickyDropdown = document.querySelector('.sticky-wrapper #sticky_rc_shipping_interval_frequency') || false;

        if (stickyDropdown) {
          formsProduct &&
            formsProduct.forEach((form) => {
              if (form && form.querySelector('#rc_shipping_interval_frequency')) {
                form.querySelector('#rc_shipping_interval_frequency').addEventListener('change', (e) => {
                  document.querySelector('.sticky-btn__inner #sticky_rc_shipping_interval_frequency').value = e.target.value;
                  /* Commented out for A/B test, add back depending on winning test */
                  // form.querySelector('#rc_purchase_type_autodeliver').value = e.target.value;
                });
              }
            });
        }

        // On change of sticky SnS frequency, update buybox frequency
        stickyDropdown &&
          stickyDropdown.addEventListener('change', (el) => {
            const currentStickyValue = el.currentTarget.value;
            const buyBoxRcValue = document.querySelector('.product-form select[name="rc_shipping_interval_frequency"]');
            const buyBoxSellingPlan = document.querySelector('.product-form input[name="selling_plan"]');
            if (currentStickyValue != buyBoxRcValue.value) {
              buyBoxRcValue.value = currentStickyValue;
              buyBoxSellingPlan.value = currentStickyValue;
            }
          });
      }

      toggleAddButton(disable) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
        } else {
          addButton.removeAttribute('disabled');
        }
      }

      setUnavailable() {
        this.toggleAddButton(true);
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (pricePerItem) pricePerItem.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
      }

      getInputSelector() {
        return 'variant-selects fieldset input[type="radio"], variant-selects select option';
      }
    }
  );
}
